module.exports = __webpack_public_path__ + "static/media/27-11.000ae7b5.mp3";